import { IHistoricalOrder } from '@rbi-ctg/menu';
import { useGetRestaurantsQuery } from 'generated/sanity-graphql';

export const useOrderTimeTimezone = (order?: IHistoricalOrder) => {
  let orderTimeTimezone;
  const storeId = order?.cart?.storeId;
  const { data: sanityRestaurantData } = useGetRestaurantsQuery({
    skip: !storeId,
    variables: {
      filter: {
        number: String(storeId),
      },
      limit: 1,
    },
  });

  if (!order?.createdAt) {
    orderTimeTimezone = 'No order time';
    return { orderTimeTimezone };
  }

  const timezone = sanityRestaurantData?.allRestaurants?.[0].timezone ?? 'UTC';
  const date = new Date(order?.createdAt);
  const orderDateTime = date.toLocaleString('en-US', { timeZone: timezone });
  const orderTime = orderDateTime.split(' ')[1];
  const timePeriod = orderDateTime.split(' ')[2];
  orderTimeTimezone = [orderTime, timePeriod, timezone].join(' ');

  return { orderTimeTimezone };
};
